import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { SECURE_BASE_URL_KEY } from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { DecryptAuthTokenType } from "../../../domain/models/auth-token/auth-token-decrypt";
import { FetchDecryptAuthToken } from "../../../domain/useages/auth-token/fetch-auth-token-decrypt";
import { RemoteFetchDecryptAuthToken } from "../../../data/usecases/auth-token/remote-fetch-decrypt-auth-token";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchDecryptAuthTokenInterface {
  FetchDecryptAuthToken: DecryptAuthTokenType;
  FetchDecryptAuthTokenState: FetchState;
  fetchDecryptAuthToken: Function;
}

const initialStates = {
  FetchDecryptAuthToken: {} as DecryptAuthTokenType,
  FetchDecryptAuthTokenState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchDecryptAuthTokenSlice: StateCreator<
  FetchDecryptAuthTokenInterface
> = (set) => ({
  ...initialStates,
  fetchDecryptAuthToken: async (params: FetchDecryptAuthToken.Params) => {

    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    const remoteFetchDecryptAuthToken = new RemoteFetchDecryptAuthToken(
      `${BASE_URL}${Endpoints.FETCH_DECRYPT_AUTH_TOKEN}`,
      axiosHttpClient
    );

    set(() => ({ FetchDecryptAuthTokenState: FetchState.LOADING }));
    let result = await remoteFetchDecryptAuthToken.fetch(params);
    return result
  },
});
